import { render, staticRenderFns } from "./WorkshopDetail.vue?vue&type=template&id=0bc35bc8&scoped=true&"
import script from "./WorkshopDetail.vue?vue&type=script&lang=js&"
export * from "./WorkshopDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopDetail.vue?vue&type=style&index=0&id=0bc35bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc35bc8",
  null
  
)

export default component.exports